const PopupLayout = ({ children }: any) => {
    return <div className="p-4">{children}</div>;
};

export default PopupLayout;
